import api from "@/api/zfb/auth";
import { Service_Tb1688FxAppKey, Service_ShowAliAuthModal } from "@/service/tb_1688_service";
import { Service_GetBranchRelId, Service_SetDefaultAppToLocal } from "@/service/branch_relId_service";
import { Service_GetZfbMemberInfo, Service_AppKey } from "@/service/platform_config";
import { message } from "ant-design-vue";
import { Service_SetPddMoveInfo } from "@/service/auth_mall_service";
import categoryApi from "@/views/moving_function/components/mall_category_select2/api";
import { COU_formatDateToStr } from "@/utils/co_utils";
import store from "@/store";
// 获取单店铺
function GetFormatMallData() {
  const localMallData = Service_GetZfbMemberInfo();
  if (!localMallData?.token) return [];
  return [
    {
      isSingle: true,
      AppKey: Service_AppKey,
      ShopId: localMallData.shop_id,
      Id: localMallData.shop_id,
      auth: {
        PlatformType: localMallData.platform_type,
        ShopName: localMallData.shop_name,
        AppExpiresIn: "-",
      },
    },
  ];
}

// 把店铺信息以及1688授权信息存到本地
async function SetLocalData(type) {
  if (!GetFormatMallData().length) return;
  // 获取1688授权应用列表
  const { authMallList } = await api.GetAuthAppList(1, 100, null, Service_Tb1688FxAppKey);

  // 如果一个1688授权都没有则需要先授权一个
  if (!authMallList?.length) {
    // 获取授权链接
    const authUrl = await api.GetAddAuthAppLink(Service_Tb1688FxAppKey);
    await Service_ShowAliAuthModal(
      authUrl,
      "检测到当前店铺需要先授权订购1688应用【晓风分销】才能继续使用1688选品铺货代发等功能"
    );
    // 确认下是不是已经授权成功了
    const { authMallList } = await api.GetAuthAppList(1, 100, null, Service_Tb1688FxAppKey);
    if (!authMallList?.length) return SetLocalData(type);
    setData(authMallList[0]);
  } else {
    var branchId = Service_GetBranchRelId(Service_GetZfbMemberInfo());
    if (!branchId) {
      setData(authMallList[0]);
    } else {
      var currentItem = authMallList.find((item) => {
        return item.RelId == branchId;
      });
      if (!currentItem) setData(authMallList[0]);
    }
  }
  // 优先找付费版的并且没有过期的1688授权账号
  Service_SetPddMoveInfo(GetFormatMallData());
  if (type !== "hide-msg") {
    message.success("检测到已完成1688授权，将刷新页面 !");
    window.location.reload();
  }
}

// 如果授权成功过了则存下店铺信息以及1688授权信息 (relation, appInfo)
function setData(aliItem) {
  Service_SetDefaultAppToLocal(Service_GetZfbMemberInfo(), aliItem); // 存下当前店铺对应的1688授权relId
}

// 是否帮用户同步一次类目
async function SyncCategory() {
  const key = "xf_zfb_fenxiao_is_auto_sync_mall_category_list";
  const flag = localStorage.getItem(key);

  // const { list, success } = await categoryApi.GetGoodsCategoryList();
  const { list, success } = await store.dispatch("mall_group/getMallCategory");
  // 说明还没自动同步过类目, 则帮用户同步类目一次
  if (!flag || (!list.length && !success)) {
    categoryApi.GetGoodsCategoryList(true);
    localStorage.setItem(key, `同步类目 【${COU_formatDateToStr()}】`);
  }
}

export default {
  GetFormatMallData,
  SetLocalData,
  SyncCategory,
};
